// extracted by mini-css-extract-plugin
export default {"row":"styles_row__eSev6","col-name":"styles_col-name__h2rWZ"};